<div class="prefixed-input">
  <span class="input-prefix">{{ prefix }}</span>
  <input
    type="text"
    [id]="id"
    [(ngModel)]="inputValue"
    [disabled]="disabled"
    [placeholder]="placeholder"
    (paste)="onPaste($event)"
    (blur)="onBlur()"
  />
</div>
